import moment, {Moment} from 'moment';
import {CareTaskComplementary} from '../../backend/interfaces/care-task-complementary';

/** A CareTaskComplementary with helpeful info */
export type CareTaskInfo = {
  id: string;
  done: boolean | undefined;
  handled: boolean;
  unattended: boolean;
  activitiesGroupEntryId?: string;
  activityTypeEntryId: string;
  rawData: CareTaskComplementary;
};

/** Create a CareTaskInfo from a CareTaskComplementary */
export function createCareTaskInfo(ctc: CareTaskComplementary, todayDate?: Moment): CareTaskInfo {
  const today = todayDate ?? moment();
  const date = moment(ctc.careTask.startsAt);
  const markedAsHandled = ctc.careTask.markedAsHandled;
  const markedAsDone = ctc.careTask.markedAsDone;
  const activitiesGroupEntryId = ctc.careTask.activitiesGroupEntryId;
  const activityTypeEntryId = ctc.careTask.activityTypeEntryId;

  return {
    id: ctc.careTask.id!,
    done: markedAsDone,
    handled: markedAsHandled,
    unattended: !markedAsHandled && date.isBefore(today),
    activitiesGroupEntryId: activitiesGroupEntryId,
    activityTypeEntryId: activityTypeEntryId,
    rawData: ctc,
  };
}
